import { useEffect, useState } from 'react';

export default function GemImage({ fileName, imageSource, alt = '', className = '' }) {
  const [url, setUrl] = useState('');

  useEffect(() => {
    let objectUrl = '';
    let cancelled = false;

    async function load() {
      if (!fileName) return;
      try {
        let file = null;
        if (imageSource?.directoryHandle) {
          const handle = await imageSource.directoryHandle.getFileHandle(fileName);
          file = await handle.getFile();
        } else if (imageSource?.fileMap?.has(fileName)) {
          file = imageSource.fileMap.get(fileName);
        }
        if (!file || cancelled) return;
        objectUrl = URL.createObjectURL(file);
        if (!cancelled) setUrl(objectUrl);
      } catch {
        if (!cancelled) setUrl('');
      }
    }

    setUrl('');
    load();
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [fileName, imageSource]);

  if (!url) return <div className={`image-placeholder ${className}`}>🖼️</div>;
  return <img className={`gem-image ${className}`} src={url} alt={alt || fileName} loading="lazy" />;
}
